import React from "react";
import { Tooltip } from "@material-ui/core";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import ErrorToast from "@components/Common/ErrorTost";

function ToggleStateSwitch({
    e,
    oneShop,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsActivationDeactivationModalOpened,
    setDataState,
    isModeOfSaleArchived,
    isLoading,
    t,
    setModalState,
}: any) {
    const handleToggleStateChange = ({
        selectedRow,
        oneShop,
        isEdited,
        setIsActionsClicked,
        setActions,
        setIsEdited,
        setIsActivationDeactivationModalOpened,
        setDataState,
        t,
    }: any) => {
        if (selectedRow.isFavorite === true && oneShop) {
            ErrorToast(
                t("Please note, you cannot deactivate a favorite mode of sale")
            );
        } else {
            if (isEdited === true) {
                setIsActionsClicked((prev: any) => !prev);
                setActions(() => {
                    setIsEdited(false);
                    setModalState((prev: any) => ({
                        ...prev,
                        isAddModeOfSaleClicked: false,
                    }));
                    setIsActivationDeactivationModalOpened(true);
                    setDataState({
                        id: selectedRow.Id,
                        state: !selectedRow.state,
                    });
                });
            } else {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: false,
                }));
                setIsActivationDeactivationModalOpened(true);
                setDataState({
                    id: selectedRow.Id,
                    state: !selectedRow.state,
                });
            }
        }
    };

    if (!oneShop) return null;
    return (
        <Tooltip
            title={
                isModeOfSaleArchived
                    ? ""
                    : e.selectedRow.state === false
                    ? t("Activate")
                    : t("Unactivate")
            }
        >
            <div>
                <ReactSwitch
                    uncheckedIcon={false}
                    checkedIcon={false}
                    handleDiameter={26}
                    offColor="#f7b4b8"
                    offHandleColor="#E30613"
                    checked={e.selectedRow.state}
                    onChange={() =>
                        handleToggleStateChange({
                            selectedRow: e.selectedRow,
                            oneShop,
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setIsEdited,
                            setIsActivationDeactivationModalOpened,
                            setDataState,
                            t,
                        })
                    }
                    onColor="#c2eddd"
                    onHandleColor="#34C38F"
                    width={50}
                    height={20}
                    className={classnames(
                        "pointer__clz mdv_icn_BTenableDisable",
                        {
                            "not-allowed-icon__clz":
                                isModeOfSaleArchived || isLoading,
                        },
                        oneShop ? "mr-2" : "ml-3"
                    )}
                />
            </div>
        </Tooltip>
    );
}

export default ToggleStateSwitch;
